<script setup>
</script>

<template>
    <router-view />
</template>
<style>
    /* Hide the expanded icon by default when the button is collapsed */
    /*button[aria-expanded="false"] .icon-expanded {
        display: none;
    }*/
    button:not(.collapsed) .icon-expanded {
        display: none;
    }

    /* Hide the collapsed icon when the button is actively expanded */
    /*button[aria-expanded="true"] .icon-collapsed {
        display: none;
    }*/
    button.collapsed .icon-collapsed {
        display: none;
    }

    /* Hide the 'expanded' icon by default when the button is collapsed */
    /*.btn.collapsed .icon-expanded {
        display: none;
    }*/

    /* Hide the 'collapsed' icon when the button is open (not collapsed) */
    /*.btn:not(.collapsed) .icon-collapsed {
        display: none;
    }*/

    .list-enter-active,
    .list-leave-active {
        transition: all 0.5s ease;
    }

    .list-enter-from,
    .list-leave-to {
        opacity: 0;
        transform: translateX(30px);
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s ease;
    }

    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
    }

    .slide-fade-enter-active {
        transition: all 0.3s ease-out;
    }

    .slide-fade-leave-active {
        transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .slide-fade-enter-from,
    .slide-fade-leave-to {
        transform: translateX(20px);
        opacity: 0;
    }
</style>